module.exports = __webpack_public_path__ + "static/media/ottawa-6.8a54d7ff.jpg";